export function isPublicEventsPath(pathname) {
    return /^\/(?:events|eventos)(?:\/|$)/.test(pathname);
}
